import hasContainer from "@root/helpers/has-container";

const getContainerSizeClass = (moduleSettings) => {
    const classes = [];

    const containerClass = hasContainer(true);
    if (moduleSettings?.containerWidth !== "wide") {
        classes.push(containerClass);
    }

    if (moduleSettings?.containerWidth) {
        classes.push(`container-width-${moduleSettings.containerWidth}`);
    }

    return classes;
};

export default getContainerSizeClass;
